import { Box, BoxProps, Flex, Spacer } from "@chakra-ui/react";

import { displayNumber } from "@/utils/get-display-number";

interface LegendGradient extends BoxProps {
  legendId: string;
  legend: {
    value: number;
    color: string;
  }[];
  withLabel?: boolean;
  unit?: string;
  isHorizontal?: boolean /* default is vertical */;
}

export function LegendGradient({
  legend,
  legendId,
  withLabel,
  unit,
  isHorizontal,
  ...rest
}: LegendGradient) {
  const lastLegendStep = legend[legend.length - 1].value;
  const maxValue = displayNumber(lastLegendStep);
  const minValue = displayNumber(legend[0].value);

  return (
    <Flex flexDir={isHorizontal ? "column" : "row"}>
      <Box
        w={isHorizontal ? "100%" : "100px"}
        h={isHorizontal ? "20px" : "200px"}
        borderRadius={2}
        overflow="hidden"
        {...rest}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 100 100"
          preserveAspectRatio="none" /* to make rectangular viewBox fit non-rectangular shape */
        >
          <defs>
            <linearGradient
              id={legendId}
              x1="0%"
              y1="0%"
              x2={isHorizontal ? "100%" : "0%"}
              y2={isHorizontal ? "0%" : "100%"}
            >
              {legend.map((step, i) => (
                <stop
                  key={step.value + step.color + i}
                  offset={`${(i / (legend.length - 1)) * 100}%`}
                  stopColor={step.color}
                />
              ))}
            </linearGradient>
          </defs>
          <rect x="0" y="0" width="100" height="100" fill={`url(#${legendId})`} />
        </svg>
      </Box>
      {withLabel ? (
        <Flex
          flexDir={isHorizontal ? "row" : "column"}
          fontSize={10}
          fontWeight={600}
          ml={isHorizontal ? 0 : 2}
          color="grey"
        >
          <span>
            {minValue} {unit}
          </span>
          <Spacer />
          <span>
            {maxValue} {unit}
          </span>
        </Flex>
      ) : null}
    </Flex>
  );
}
